module.exports = __webpack_public_path__ + "img/Wp_2060.17590161.png";